import { Box, Typography } from '@mui/material'

import callIcon from 'assets/images/link-page-icons/call-icon.svg'
import gpsIcon from 'assets/images/link-page-icons/gps-icon.svg'

export const TrackingNotFoundMessage = () => {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' minHeight='50vh' p={3}>
      <Box sx={{ maxWidth: 600 }}>
        <Typography
          variant='h3'
          gutterBottom
          textAlign='left'
          sx={{ fontFamily: 'Goldplay-Bold', fontSize: '36px', mb: 2 }}>
          This tracking link does not exist.
        </Typography>
        <Typography
          variant='body1'
          paragraph
          textAlign='left'
          sx={{ fontFamily: 'Goldplay-Regular', fontSize: '18px' }}>
          Please contact FPL team for support.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box component='img' src={callIcon} alt='Phone' sx={{ width: 60, height: 60 }} />
            <Box>
              <Typography
                variant='body1'
                fontWeight='bold'
                sx={{ fontFamily: 'Goldplay-Bold', fontSize: '18px' }}>
                Call us
              </Typography>
              <Typography variant='body1' sx={{ fontFamily: 'Goldplay-Regular', fontSize: '18px' }}>
                0345 030 3777
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box component='img' src={gpsIcon} alt='Location' sx={{ width: 60, height: 60 }} />
            <Box>
              <Typography
                variant='body1'
                fontWeight='bold'
                sx={{ fontFamily: 'Goldplay-Bold', fontSize: '18px' }}>
                Find us
              </Typography>
              <Typography variant='body1' sx={{ fontFamily: 'Goldplay-Regular', fontSize: '18px' }}>
                Firstpoint Logistics LTD
                <br />
                A&W Buildings, The Docks,
                <br />
                Portishead, BS20 7DF
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
